import React from 'react';
import {createRoot} from 'react-dom/client';
import {flushSync} from 'react-dom';
import {Background, Button, Card, Divider, Title} from 'animal-island-ui';
import {Icon} from '../../island-icon.jsx';
import 'animal-island-ui/style';
import {SiteHeader} from '../../site-header.jsx';
import {Maintenance} from './maintenance.jsx';
import {ManagementPageProvider} from '../../i18n/management-language.jsx';

const Label = ({name}) => <span data-label={name}/>;

export function mountIslandShell() {
  const host = document.createElement('div');
  host.id = 'geocaching-app';
  document.body.replaceChildren(host);
  flushSync(() => createRoot(host).render(<ManagementPageProvider>
    <Background type="sprinkles" className="island-wallpaper" aria-hidden="true"/>
    <SiteHeader page="geocaching">
      <span id="connection-state" className="status" role="status" data-label="offline"/>
      <div id="geocaching-connection-controls"/>
    </SiteHeader>
    <main className="workspace">
      <aside className="sidebar">
        <Title color="app-teal" size="middle"><Icon name="icon-map" size={24}/> <Label name="title"/></Title>
        <Maintenance/>
        <div id="geocaching-browse-controls">
        <Card color="app-yellow" pattern="app-yellow" className="intro">
          <h1 data-label="heading"/><p data-label="intro"/>
          <p data-label="extraIntro"/>
          <a href="https://github.com/vicliu624/trail-mate/wiki/20.-Geocaching-Developer-Guide" data-label="documentation"/>
        </Card>
        <p id="directory-status" className="help" data-label="noDirectory"/>
        <fieldset className="region-filters">
          <legend data-label="region"/>
          <label htmlFor="region-kind" data-label="regionKind"/>
          <select id="region-kind" defaultValue="map">
            <option value="map" data-label="mapRegion"/>
            <option value="countries" data-label="countries"/>
            <option value="seas" data-label="seas"/>
          </select>
          <div id="region-picker" hidden>
            <label htmlFor="region-search" data-label="findRegion"/>
            <input id="region-search" type="search" autoComplete="off"/>
            <label htmlFor="region-select" data-label="chooseRegion"/>
            <select id="region-select" disabled defaultValue=""><option value="" data-label="chooseRegion"/></select>
          </div>
          <p id="region-state" className="help" aria-live="polite"/>
          <a className="boundary-credit" href="./data/README.md">Natural Earth · Marine Regions / IHO · CC BY 4.0</a>
          <Button id="region-apply" type="primary" disabled><Label name="searchRegion"/></Button>
        </fieldset>
        <fieldset className="filters"><legend data-label="show"/>
          {['active','disabled','archived'].map((name,i)=><label key={name}><input type="checkbox" name="state" value={1<<i} defaultChecked={i<2}/><Label name={name}/></label>)}
        </fieldset>
        <Divider type="dashed-brown"/>
        <div className="results-heading"><h2 id="result-count" data-label="emptyCount"/><span id="selection-count"/></div>
        <p id="notice" role="status" data-label="start"/>
        <ol id="results" className="results"/>
        <div className="result-actions">
          <Button id="more" hidden><Label name="more"/></Button>
          <Button id="download-selected" disabled type="primary"><Label name="downloadSelected"/></Button>
          <Button id="download-partial" hidden><Label name="downloadPartial"/></Button>
        </div>
        <p className="scope" data-label="scope"/>
        <a className="library-credit" href="https://guokaigdg.github.io/animal-island-ui/">Animal Island UI</a>
        </div>
      </aside>
      <section className="map-panel" data-geo-aria="mapAria">
        <div id="map"/>
        <div className="map-tools"><Button id="search" type="primary" disabled icon={<Icon name="icon-map" size={20}/>}><Label name="search"/></Button>
          <Button id="locate" data-geo-aria="locateAria" icon={<Icon name="location" size={22}/>}/></div>
        <p id="map-state" className="map-state" role="status"/>
        <Card id="detail" className="detail" hidden aria-live="polite">
          <Button id="close-detail" className="close" type="text" data-geo-aria="closeAria">×</Button>
          <span id="detail-state" className="eyebrow"/><h2 id="detail-name"/>
          <p id="detail-coordinates" className="coordinates"/><div id="detail-content"/>
          <Button id="download-one" type="primary" disabled><Label name="download"/></Button>
        </Card>
      </section>
    </main>
  </ManagementPageProvider>));
}
